// assets/js/gsap.js

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

window.gsap = gsap;

window.runGsapFadeUp = function (scope = document) {
    const fadeUpItems = scope.querySelectorAll(".gsap-fade-up");
    const fadeUpBtns = scope.querySelectorAll(".gsap-fade-up-btn");

    if (fadeUpItems.length) {
        gsap.killTweensOf(fadeUpItems);

        gsap.to(fadeUpItems, {
            y: 0,
            autoAlpha: 1,
            duration: 1,
            stagger: 0.15,
            ease: "power2.out"
        });
    }

    if (fadeUpBtns.length) {
        gsap.killTweensOf(fadeUpBtns);

        gsap.to(fadeUpBtns, {
            y: 0,
            autoAlpha: 1,
            duration: 1,
            ease: "power2.out"
        });
    }
};

function initGallerySlider() {
    const sliders = document.querySelectorAll(".ttli__gal-slider");

    sliders.forEach((slider) => {
        const slides = slider.querySelectorAll(".ttli__gal-slide");
        if (!slides.length) return;

        let currentIndex = 0;
        let isAnimating = false;

        const visibleSlide = slider.querySelector(".ttli__gal-slide.is-visible");
        if (visibleSlide) {
            currentIndex = Array.from(slides).indexOf(visibleSlide);
        }

        // Initial state
        gsap.set(slider, { position: "relative" });

        slides.forEach((slide, index) => {
            gsap.set(slide, {
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                opacity: index === currentIndex ? 1 : 0,
                visibility: index === currentIndex ? "visible" : "hidden",
                zIndex: index === currentIndex ? 2 : 1
            });

            slide.classList.toggle("is-visible", index === currentIndex);
        });

        function goToSlide(nextIndex) {
            if (isAnimating || nextIndex === currentIndex) return;

            const currentSlide = slides[currentIndex];
            const nextSlide = slides[nextIndex];

            isAnimating = true;

            nextSlide.classList.add("is-visible");
            gsap.set(nextSlide, {
                visibility: "visible",
                zIndex: 3,
                opacity: 0
            });

            gsap.set(currentSlide, {
                zIndex: 2,
                visibility: "visible"
            });

            const tl = gsap.timeline({
                onComplete: () => {
                    currentSlide.classList.remove("is-visible");
                    currentIndex = nextIndex;
                    isAnimating = false;
                }
            });

            tl.to(currentSlide, {
                opacity: 0,
                duration: 0.6,
                ease: "power2.out"
            }, 0);

            tl.to(nextSlide, {
                opacity: 1,
                duration: 0.6,
                ease: "power2.out"
            }, 0);
        }

        function nextSlide() {
            const nextIndex = (currentIndex + 1) % slides.length;
            goToSlide(nextIndex);
        }

        // autoplay
        setInterval(nextSlide, 3000);
    });
}

document.addEventListener("DOMContentLoaded", () => {
    const fadeUpItems = Array.from(document.querySelectorAll(".gsap-fade-up"))
        .filter((el) => !el.closest(".hero-slider"));

    const fadeUpBtns = Array.from(document.querySelectorAll(".gsap-fade-up-btn"))
        .filter((el) => !el.closest(".hero-slider"));

    const scrollItems = document.querySelectorAll(".gsap-scroll");

    if (fadeUpItems.length) {
        gsap.from(fadeUpItems, {
            y: 40,
            autoAlpha: 0,
            duration: 1,
            stagger: 0.15,
            ease: "power2.out",
            clearProps: "opacity,visibility,transform"
        });
    }

    if (fadeUpBtns.length) {
        gsap.from(fadeUpBtns, {
            y: 40,
            autoAlpha: 0,
            duration: 1,
            ease: "power2.out",
            clearProps: "opacity,visibility,transform"
        });
    }

    if (scrollItems.length) {
        scrollItems.forEach((el) => {
            gsap.from(el, {
                y: 50,
                autoAlpha: 0,
                duration: 0.9,
                ease: "power2.out",
                clearProps: "opacity,visibility,transform",
                scrollTrigger: {
                    trigger: el,
                    start: "top 85%",
                    toggleActions: "play none none none"
                }
            });
        });
    }

    initFadeUpAnimations();

    initGallerySlider();
});


window.initFadeUpAnimations = function (scope = document, animateNow = false) {
    let groups = Array.from(scope.querySelectorAll(".group-fade-up"));

    if (scope.classList && scope.classList.contains("group-fade-up")) {
        groups.unshift(scope);
    }

    groups.forEach((group) => {
        const items = group.querySelectorAll(".fade-up:not(.fade-up-initialized)");
        if (!items.length) return;

        items.forEach((item) => item.classList.add("fade-up-initialized"));

        gsap.from(items, {
            y: 40,
            autoAlpha: 0,
            duration: 1,
            stagger: 0.2,
            ease: "power2.out",
            clearProps: "opacity,visibility,transform",
            scrollTrigger: animateNow ? null : {
                trigger: group,
                start: "top 85%",
                toggleActions: "play none none none"
            }
        });
    });

    const singles = Array.from(scope.querySelectorAll(".fade-up:not(.fade-up-initialized)"))
        .filter((el) => !el.closest(".group-fade-up"));

    singles.forEach((el) => {
        el.classList.add("fade-up-initialized");

        gsap.from(el, {
            y: 40,
            autoAlpha: 0,
            duration: 1,
            ease: "power2.out",
            clearProps: "opacity,visibility,transform",
            scrollTrigger: animateNow ? null : {
                trigger: el,
                start: "top 85%",
                toggleActions: "play none none none"
            }
        });
    });

    // Fade from left
    const fadeLeftItems = Array.from(
        scope.querySelectorAll(".fade-left:not(.fade-left-initialized)")
    );

    fadeLeftItems.forEach((el) => {
        el.classList.add("fade-left-initialized");

        gsap.from(el, {
            x: -50,
            autoAlpha: 0,
            duration: 1,
            ease: "power2.out",
            clearProps: "opacity,visibility,transform",
            scrollTrigger: animateNow ? null : {
                trigger: el,
                start: "top 85%",
                toggleActions: "play none none none"
            }
        });
    });

    // Fade from right
    const fadeRightItems = Array.from(
        scope.querySelectorAll(".fade-right:not(.fade-right-initialized)")
    );

    fadeRightItems.forEach((el) => {
        el.classList.add("fade-right-initialized");

        gsap.from(el, {
            x: 50,
            autoAlpha: 0,
            duration: 1,
            ease: "power2.out",
            clearProps: "opacity,visibility,transform",
            scrollTrigger: animateNow ? null : {
                trigger: el,
                start: "top 85%",
                toggleActions: "play none none none"
            }
        });
    });

    if (!animateNow) {
        ScrollTrigger.refresh();
    }
};


gsap.registerPlugin(ScrollTrigger);

document.querySelectorAll('.path__steps').forEach((path) => {
    const steps = gsap.utils.toArray(path.querySelectorAll('.path__step'));

    gsap.set(steps, { opacity: 0.2 });
    gsap.set(path.querySelectorAll('.path__step-line'), {
        scaleX: 0,
        transformOrigin: 'left center'
    });

    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: path,
            start: 'top bottom',
            once: true,
            immediateRender: true
        }
    });

    steps.forEach((step) => {
        const line = step.querySelector('.path__step-line');

        tl.to(step, {
            opacity: 1,
            duration: 0.35,
            ease: 'power2.out'
        });

        if (line) {
            tl.to(line, {
                scaleX: 1,
                duration: 0.45,
                ease: 'power2.inOut'
            }, '-=0.1');
        }
    });
});

ScrollTrigger.refresh();